import React, { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../../styles/global.css";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-white text-primary-800 font-sans selection:bg-accent-200 selection:text-primary-900 flex flex-col">
      <Header />
      <main className="flex-grow min-h-[calc(100vh-400px)]">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
